import React from 'react';
import { updatedata } from "../../util/global";
import { locationitem } from './Datatype';

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  formdata: locationitem;
  setformdata: (data: locationitem) => void;
  fetchdata: () => void;
}

const LocationForm: React.FC<props> = ({
  showmodal,
  setshowmodal,
  formdata,
  setformdata,
  fetchdata
}) => {
  if (showmodal !== "showlocationform") return null;

  const handlesave = async () => {
    const payload = {
      data: {
        ...formdata,
        datatype: "locationdata"
      }
    };
    await updatedata(payload);
    setshowmodal("");
    fetchdata();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "edit location" : "add location"}</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>zone code</label>
            <input
              type="text"
              className="form-input"
              value={formdata.code || ''}
              onChange={(e) => setformdata({ ...formdata, code: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>serviceable pins (comma separated)</label>
            <input
              type="text"
              className="form-input"
              value={formdata.pins || ''}
              onChange={(e) => setformdata({ ...formdata, pins: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>capacity limit</label>
            <input
              type="number"
              className="form-input"
              value={formdata.capacitylimit || ''}
              onChange={(e) => setformdata({ ...formdata, capacitylimit: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>status</label>
            <select
              className="form-input"
              value={formdata.status || 'open'}
              onChange={(e) => setformdata({ ...formdata, status: e.target.value })}
            >
              <option value="open">open</option>
              <option value="closed">closed</option>
            </select>
          </div>

          <button className="btn-blue full-width" onClick={handlesave}>
            save location
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationForm;
